// extracted by mini-css-extract-plugin
export default {"sectionTitle":"Title_sectionTitle__2Tyl9","title":"Title_title__E4IyZ","subtitle":"Title_subtitle__3BNi3","titleShadow":"Title_titleShadow__g4Qti"};